import { Component, HostBinding } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-radio-exp',
  styleUrls: ['form-radioExp.component.scss'],
  imports: [
    FormlyModule,
    MatIconModule,
    MatRadioModule,
    MatInputModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
  template: `
    @if (props.label) {
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
      <label
        class="section w-100"
        [class.mat-error]="formControl.errors && formControl.touched"
      >
        <span tabindex="0" [innerHTML]="props.label"></span>
        @if (props.required) {
          <sup>*</sup>
        }
        @if (props.help) {
          <span
            matTooltip="{{ props.help }}"
            aria-label="help"
            tabindex="0"
            [matTooltipPosition]="'above'"
            [matTooltipClass]="'rb-tooltip'"
          >
            <mat-icon class="col-1 help-icon"> help </mat-icon>
          </span>
        }
      </label>
    }
    @if (props.prompt) {
      <p
        class="explanation"
        [class.mat-error]="formControl.errors && formControl.touched"
      >
        <span tabindex="0" [innerHTML]="props.prompt"></span>
        @if (props.required && !to.label && !to.placeholder) {
          <span> *</span>
        }
        @if (props.help && !to.label && !to.placeholder) {
          <mat-icon
            matTooltip="{{ to.help }}"
            class="help-icon"
            tabindex="0"
            [matTooltipPosition]="'above'"
            [matTooltipClass]="'rb-tooltip'"
          >
            help
          </mat-icon>
        }
      </p>
    }
    @if (props.placeholder) {
      <p
        class="italic"
        [class.mat-error]="formControl.errors && formControl.touched"
      >
        <span tabindex="0" [innerHTML]="props.placeholder"></span>
        @if (props.required && !to.label) {
          <span> *</span>
        }
        @if (props.help && !to.label && !to.prompt) {
          <mat-icon
            matTooltip="{{ to.help }}"
            class="help-icon"
            tabindex="0"
            [matTooltipPosition]="'above'"
            [matTooltipClass]="'rb-tooltip'"
          >
            help
          </mat-icon>
        }
      </p>
    }

    <mat-radio-group
      class="radio-group radio-group-explanation col-12 questionnaire"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [required]="props.required"
      (change)="changeTime()"
    >
      @for (opt of props?.options; track $index) {
        <mat-radio-button
          id="{{ field.key }}-{{ $index }}"
          class="radio-button"
          [value]="opt.value"
        >
          {{ opt.label }}
        </mat-radio-button>
      }
      @if (field.props.imageName) {
        <img
          alt="{{ field.props.imageName }}"
          [src]="'./assets/' + field.props.imageName"
        />
      }
      @if (
        formControl.hasError('required') &&
        formControl.touched &&
        !formControl.hasError('regRequired')
      ) {
        <mat-error> This field is required </mat-error>
      }
      @if (formControl.hasError('regRequired') && formControl.touched) {
        <mat-error>
          This field is needed for suitability review. You can opt out below if
          the applicant refuses to provide the information.
        </mat-error>
      }
    </mat-radio-group>
  `,
})
export class FormlyRadioExpComponent extends FieldType {
  @HostBinding('class') classes = 'bottom-margin';

  changeTime() {
    if (this.props?.change) {
      this.props.change(this.field, this.formControl);
    }
  }
}
